import { createContext } from 'react';
import {
	TFileId,
	IItemForGetShortInfo,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	TCategoryType,
	IUpdateCategoryV2,
} from 'types';

export type TTCategoryType = Nullable<TCategoryType>;
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface IEditCategoryState {
	needRefetchData: boolean;
	isLoading: boolean;
	filePath: Nullable<string>;
	fileId: TFileId;
	categoryID: string;
	fetchedCustomers: IItemForGetShortInfo[];
	initialIDSelectedCustomer: Nullable<string>;
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	initialIDsSelectedRestaurant: string[];
	IDsSelectedRestaurant: string[];
	nameOfCategory: string;
	categoryType: TTCategoryType;
	isRestricted: boolean;
	hasSchedulePriority: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	dataForSubmit: Nullable<IUpdateCategoryV2>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editCategoryInitialState: IEditCategoryState = {
	needRefetchData: false,
	isLoading: true,
	filePath: null,
	fileId: null,
	categoryID: '',
	fetchedCustomers: [],
	initialIDSelectedCustomer: null,
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	initialIDsSelectedRestaurant: [],
	IDsSelectedRestaurant: [],
	nameOfCategory: '',
	categoryType: null,
	isRestricted: false,
	hasSchedulePriority: false,
	activationSchedule: '',
	deactivationSchedule: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditCategoryContext extends IEditCategoryState {
	refetchData(value: boolean): void;
	changeLoaderStatus(value: boolean): void;
	setFileId(value: TFileId): void;
	deletePhoto(): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	changeNameOfCategory(value: string): void;
	setCategoryType(value: TTCategoryType): void;
	toggleIsRestricted(): void;
	toggleHasSchedulePriority(): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setDefaultCustomerLanguage(value: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: IUpdateCategoryV2): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const EditCategoryContext = createContext<IEditCategoryContext>({
	refetchData: () => undefined,
	changeLoaderStatus: () => undefined,
	setFileId: () => undefined,
	deletePhoto: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	changeNameOfCategory: () => undefined,
	setCategoryType: () => undefined,
	toggleIsRestricted: () => undefined,
	toggleHasSchedulePriority: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setDefaultCustomerLanguage: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...editCategoryInitialState,
});
